import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: "pokoje_kafel"
    });
};

export const hitGtmFilterBudgetInBox = (isInstalmentFilter: boolean) => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: `budżet_kafel${isInstalmentFilter ? "_rata" : "_kwota"}`
    });
};

const sharedParams = {
    event: "GAEvent",
    GAEventCategory: "ui",
    GAEventAction: "filtry",
    GAEventNoInteraction: false
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: "pokoje_kafel"
    });
};

export const hitGtmFilterBudgetInBox = (isInstalmentFilter: boolean) => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: `budżet_kafel${isInstalmentFilter ? "_rata" : "_kwota"}`
    });
};

const sharedParams = {
    event: "GAEvent",
    GAEventCategory: "ui",
    GAEventAction: "filtry",
    GAEventNoInteraction: false
};
